<template>
  <div class="pick-lottery-quick-pick-button">
    <LcButton
      v-bind="{ disabled, icon, size, variant }"
      class="button"
      no-padding
      @click="isModalVisible = true"
    >
      {{ $t('lottery.quickpick.button') }}
    </LcButton>

    <PickLotteryQuickPickModal
      v-if="isModalVisible"
      v-bind="modalProps"
      @close="isModalVisible = false"
      @confirm="onConfirm"
    />
  </div>
</template>

<script lang="ts" setup>
import type { LcButtonProps } from '@lottocom/frontend-components'

import type {
  PickLotteryQuickPickModalConfirmPayload,
  PickLotteryQuickPickModalEmits,
  PickLotteryQuickPickModalProps,
} from './PickLotteryQuickPickModal.vue'

type PickLotteryQuickPickProps = Pick<LcButtonProps, 'disabled' | 'icon' | 'size' | 'variant'> &
  PickLotteryQuickPickModalProps & {
    closeModalOnConfirm?: boolean
  }

const emit = defineEmits<PickLotteryQuickPickModalEmits>()
const { closeModalOnConfirm, disabled, icon, size, variant, ...modalProps } =
  defineProps<PickLotteryQuickPickProps>()

const isModalVisible = ref(false)

const onConfirm = (payload: PickLotteryQuickPickModalConfirmPayload) => {
  if (closeModalOnConfirm) isModalVisible.value = false
  emit('confirm', payload)
}
</script>

<style lang="scss" scoped>
.pick-lottery-quick-pick-button {
  &,
  .button {
    width: 100%;
  }
}
</style>
